<template>
  <div>
    <!-- 分账批次管理 -->
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <div class="left">
            <span>分账批次管理</span>
          </div>
          <div class="right">
            <!-- 所属机构 -->
            <DepartmentChoose :department-code.sync="paramsData.departmentCode"/>

            <!--选择商户-->
            <a-select
                v-model="paramsData.merchantNo"
                allow-clear
                option-filter-prop="children"
                placeholder="请选择商户"
                show-search
                style="min-width: 300px;margin-right:50px"
            >
              <a-select-option
                  v-for="merchant in mainMerchantList"
                  :key="merchant.merchantNo"
                  :value="merchant.merchantNo"
              >
                {{ merchant.merchantName }} ({{ merchant.merchantNo }})
              </a-select-option>
            </a-select>


          </div>
        </div>
      </template>
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>批次号</span>
          <a-input v-model.trim="paramsData.batchNo" placeholder="请输入批次号" allow-clear/>
        </div>
        <div class="item">
          <span>状态</span>
          <a-select v-model.trim="paramsData.batchStatus" placeholder="请选择状态" allow-clear>
            <a-select-option v-for="(type, value) in  commonDict.batch_status" :key="value" :value="value">
              <a-tag v-if="type.show" :color="type.color">{{ type.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="item">
          <span>业务日期</span>
          <a-range-picker
              v-model="businessDateRange"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="onDateChange"
          />
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 操作按钮区域 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="handleQuery">刷新</a-button>
          <a-button type="primary" style="margin-left: 8px" @click="autoMatchBtn">批量匹配</a-button>
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :row-key="record => record.batchNo"
          >

            <template slot="action" slot-scope="text, record">
              <a-button-group size="small">
                <!-- 匹配按钮  -->
                <a-button
                    icon="link"
                    style="color: #52c41a;"
                    type="link"
                    @click="autoMatchBatchBtn(record)"
                    v-if="record.batchStatus === '0' && $authority('batchMatch')"
                >匹配
                </a-button>

                <!-- 查看按钮 -->
                <a-button
                    icon="eye"
                    style="color: #1890ff;"
                    type="link"
                    @click="viewBtn(record)"
                    v-if="$authority('batchView')"
                >查看
                </a-button>

                <!-- 清分确认按钮 -->
                <a-button
                    icon="file-text"
                    style="color: #fa8c16;"
                    type="link"
                    @click="genPlanByBatchBtn(record)"
                    v-if="(record.batchStatus === '1'  ) && $authority('batchSettleConfirm')"
                >清分确认
                </a-button>
                <a-button
                    type="link"
                    icon="check-circle"
                    @click="settleBtn(record)"
                    v-if="record.batchStatus === '2'"
                >
                  执行
                </a-button>
                <!-- 作废按钮 -->
                <a-button
                    icon="close"
                    style="color: #ff4d4f;"
                    type="link"
                    @click="invalidBtn(record)"
                    v-if="canInvalid(record.batchStatus) && $authority('batchInvalid')"
                >作废
                </a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="paginationBox">
        <LcfsPagination
            :page-no.sync="pagination.pageNo"
            :page-size.sync="pagination.pageSize"
            :total="pagination.total"
            :fn="getTableData"
        />
      </div>
    </a-card>

    <!-- 批次详情弹窗 -->
    <a-modal
        v-model="viewModalVisible"
        title="分账批次详情"
        @cancel="viewModalVisible = false"
        width="75%"
        :footer="null"
        :destroyOnClose="true"
        :bodyStyle="{ padding: '24px' }"
    >
      <div v-if="viewData" class="batch-detail">
        <!-- 1. 批次基本信息 -->
        <a-card title="批次基本信息" size="small" :bordered="false" class="detail-section">
          <a-descriptions bordered :column="2" size="small">
            <a-descriptions-item label="批次号">
              <span class="detail-value copyable">{{ viewData.batchNo }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="商户信息">
              <span class="detail-value">{{ viewData.merchantNo }} - {{ viewData.merchantName }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="业务日期">
              <span class="detail-value">{{ viewData.businessDate }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="批次状态">
              <a-tag :color="batch_status(viewData.batchStatus).color">
                {{ batch_status(viewData.batchStatus).label }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="订单笔数">
              <span class="detail-value">{{ viewData.orderCount }} 笔</span>
            </a-descriptions-item>
            <a-descriptions-item label="订单金额">
              <span class="amount-primary">¥{{ formatAmount(viewData.orderAmount) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="分账金额总额">
              <span class="amount-success">¥{{ formatAmount(viewData.splitAmountTotal) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="作废原因" v-if="viewData.invalidReason" :span="2">
              <span class="text-danger">{{ viewData.invalidReason }}</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>

        <!-- 2. 分账明细 -->
        <a-card
            v-if="viewData.batchSplitData && viewData.batchSplitData.length > 0"
            title="分账明细"
            size="small"
            :bordered="false"
            class="detail-section"
        >
          <a-table
              :columns="detailColumns"
              :data-source="viewData.batchSplitData"
              :pagination="false"
              size="small"
              :scroll="{ x: true }"
          >
          </a-table>
        </a-card>

        <!-- 3. 匹配的流水列表 -->
        <a-card
            v-if="viewData.matchedFlows && viewData.matchedFlows.length > 0"
            title="匹配流水"
            size="small"
            :bordered="false"
            class="detail-section"
        >
          <!-- 匹配汇总信息 -->
          <div class="stats-container">
            <a-row :gutter="16">
              <a-col :span="6">
                <div class="stat-item">
                  <div class="stat-label">已匹配笔数</div>
                  <div class="stat-value">{{ viewData.matchedCount }} 笔</div>
                </div>
              </a-col>
              <a-col :span="6">
                <div class="stat-item">
                  <div class="stat-label">已匹配金额</div>
                  <div class="stat-value amount-success">¥{{ formatAmount(viewData.matchedAmount) }}</div>
                </div>
              </a-col>
              <a-col :span="6">
                <div class="stat-item">
                  <div class="stat-label">订单金额</div>
                  <div class="stat-value amount-primary">¥{{ formatAmount(viewData.orderAmount) }}</div>
                </div>
              </a-col>
              <a-col :span="6">
                <div class="stat-item">
                  <div class="stat-label">剩余待匹配</div>
                  <div class="stat-value" :class="viewData.remainAmount > 0 ? 'amount-warning' : 'amount-success'">
                    ¥{{ formatAmount(viewData.remainAmount) }}
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>

          <!-- 流水表格 -->
          <a-table
              :columns="matchedFlowColumns"
              :data-source="viewData.matchedFlows"
              :pagination="false"
              size="small"
              :scroll="{ x: true }"
          >
          </a-table>
        </a-card>

        <!-- 4. 清分信息（仅在存在清算记录时显示） -->
        <a-card
            v-if="viewData.settleRecord"
            :title="`清分信息 - ${viewData.settleRecord.settleSerialNo}`"
            size="small"
            :bordered="false"
            class="detail-section"
        >
          <!-- 清分基本信息 -->
          <a-descriptions bordered :column="2" size="small">
            <a-descriptions-item label="清算状态">
              <div class="status-action-group">
                <a-tag :color="settle_status(viewData.settleRecord.settleStatus).color">
                  {{ settle_status(viewData.settleRecord.settleStatus).label }}
                </a-tag>
                <!-- 重试按钮优化 -->
                <a-tooltip title="重试清算" v-if="viewData.batchStatus === '4' || viewData.batchStatus === '6'">
                  <a-button
                      type="link"
                      size="small"
                      icon="reload"
                      @click="retrySettleBtn(viewData)"
                  >
                  </a-button>
                </a-tooltip>
              </div>
            </a-descriptions-item>
            <a-descriptions-item label="清算金额">
              <!-- 假设 Balance 组件支持 props，若不支持可改回原写法 -->
              <Balance :alignRight="false" :amount="viewData.settleRecord.settleAmount" prefix="￥"/>
            </a-descriptions-item>
            <a-descriptions-item label="生成时间">
              <span class="detail-value">{{ formatDateTime(viewData.settleRecord.generateTime) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="清算时间">
              <span class="detail-value">{{ formatDateTime(viewData.settleRecord.settleTime) || '-' }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="失败原因" v-if="viewData.settleRecord.failReason" :span="2">
              <span class="text-danger">{{ viewData.settleRecord.failReason }}</span>
            </a-descriptions-item>
          </a-descriptions>

          <!-- 清分明细 (改为内嵌表格，而非卡片) -->
          <div v-if="viewData.settleItems && viewData.settleItems.length > 0" style="margin-top: 16px;">
            <h4>清分明细</h4>
            <a-table
                :columns="settleItemsColumns"
                :data-source="viewData.settleItems"
                :pagination="false"
                size="small"
                :scroll="{ x: true }"
            />
          </div>
        </a-card>
      </div>

      <div v-else class="empty-state">
        <a-empty description="暂无批次数据"/>
      </div>
    </a-modal>

    <!-- 作废确认弹窗 -->
    <a-modal
        v-model="invalidModalVisible"
        title="确认作废"
        @ok="handleInvalidConfirm"
        @cancel="handleInvalidCancel"
        :confirm-loading="invalidConfirmLoading"
        width="500px"
        okText="确认作废"
        cancelText="取消"
        okType="danger"
    >
      <a-form-model
          ref="invalidForm"
          :model="invalidFormData"
          :rules="invalidFormRules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="批次号">
          <span style="font-weight: bold;">{{ invalidFormData.batchNo }}</span>
        </a-form-model-item>
        <a-form-model-item label="作废原因" prop="invalidReason">
          <a-textarea
              v-model="invalidFormData.invalidReason"
              placeholder="请输入作废原因"
              :rows="4"
              :maxLength="200"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 清分试算确认弹窗 -->
    <a-modal
        v-model="settleTryModalVisible"
        :title="`批次 - ${settleTryData.batchNo} - 清分预览`"
        :confirm-loading="settleTryonfirmLoading"
        width="80%"
    >
      <a-descriptions :column="2" size="small" bordered>
        <a-descriptions-item label="批次号">
          {{ settleTryData.batchNo }}
        </a-descriptions-item>
        <a-descriptions-item label="商户编号">
          {{ settleTryData.merchantNo }}
        </a-descriptions-item>
        <a-descriptions-item label="商户名称">
          {{ settleTryData.merchantName }}
        </a-descriptions-item>
        <a-descriptions-item label="结算账号">
          {{ settleTryData.settleAccountNo }}
        </a-descriptions-item>
        <a-descriptions-item label="结算账户">
          {{ settleTryData.settleAccountName }}
        </a-descriptions-item>
        <a-descriptions-item label="清算金额">
          <balance prefix="¥" :amount="settleTryData.settleAmount" align-right inline/>
        </a-descriptions-item>
      </a-descriptions>
      <!-- 清分明细 -->
      <a-card
          v-if="settleTryData.itemData && settleTryData.itemData.length > 0"
          title="清分明细"
          class="detail-card nested-card"
          :extra="`共 ${settleTryData.itemData.length} 条明细记录`"
      >
        <a-table
            :dataSource="settleTryData.itemData"
            :columns="settleItemColumns"
            :pagination="false"
            size="small"
            bordered
        >
        </a-table>
      </a-card>
      <template slot="footer">
        <a-button key="back" @click="handleSettleTryCel">取消</a-button>
        <a-button key="submit" type="primary" :loading="settleTryonfirmLoading" @click="genPlanByBatchConfirmBtn">确认</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import Balance from '@/view/components/Balance.vue'
import WalletInfo from "@/view/components/WalletInfo.vue";
import {commonDict} from "@/utils/bizDict/commonDict";
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";

export default {
  name: 'stlBatch',
  computed: {
    commonDict() {
      return commonDict
    }
  },
  components: {DepartmentChoose, LcfsPagination, Balance, WalletInfo},
  data() {
    return {
      pagination: {pageNo: 1, pageSize: 10, total: 0},

      // 筛选参数
      paramsData: {
        batchNo: "",
        merchantNo: "",
        merchantName: "",
        batchStatus: "",
        startDate: "",
        endDate: ""
      },
      businessDateRange: [],
      // 主商户列表
      mainMerchantList: [],
      // 表格数据
      tableData: [],

      // 查看详情
      viewModalVisible: false,
      viewData: null,

      // 作废弹窗
      invalidModalVisible: false,
      invalidConfirmLoading: false,
      invalidFormData: {
        batchNo: "",
        invalidReason: ""
      },
      invalidFormRules: {
        invalidReason: [
          {required: true, message: '请输入作废原因', trigger: 'blur'},
          {min: 2, max: 200, message: '作废原因长度在2-200个字符之间', trigger: 'blur'}
        ]
      },

      // 清分试算确认弹窗
      settleTryModalVisible: false,
      settleTryData: {},
      settleTryonfirmLoading: false,

      // 清分明细表格列配置
      settleItemColumns: [
        {
          title: '主商户信息',
          dataIndex: 'mainMerchantName',
          width: 180,
          align: "center",
          customRender: (text, record) => {
            return (
                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '4px'}}>
                    {record.mainMerchantNo}
                  </div>
                  <div style={{color: '#666', fontSize: '12px'}}>
                    {record.mainMerchantName}
                  </div>
                </div>
            );
          }
        },
        {
          title: '分商户信息',
          dataIndex: 'splitMerchantName',
          width: 180,
          align: "center",
          customRender: (text, record) => {
            return (
                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '4px'}}>
                    {record.splitMerchantNo}
                  </div>
                  <div style={{color: '#666', fontSize: '12px'}}>
                    {record.splitMerchantName}
                  </div>
                </div>
            );
          }
        },
        {
          title: '付款',
          dataIndex: 'accountName',
          width: 200,
          align: "center",
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.accountNo} accountName={record.accountName} showAccountName={true} size="small"/>);
          }
        },
        {
          title: '收款',
          dataIndex: 'oppAccountName',
          width: 200,
          align: "center",
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.oppAccountNo} accountName={record.oppAccountName} showAccountName={true} size="small"/>);
          }
        },
        {
          title: '清算金额',
          dataIndex: 'amount',
          width: 120,
          align: "center",
          customRender: (text, record) => {
            return <Balance amount={record.amount}/>
          }
        },
        {
          title: '摘要',
          align: "center",
          dataIndex: 'remark',
          width: 120,
        },
      ],

      // 表格列配置
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`,
          align: "center",
          width: 60
        },
        {
          title: "批次号",
          dataIndex: "batchNo",
          align: "center",
          width: 120,
          ellipsis: true
        },
        {
          title: "商户信息",
          align: "center",
          width: 120,
          customRender: (text, record) => {
            return (
                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '4px'}}>
                    {record.merchantNo}
                  </div>
                  <div style={{color: '#666', fontSize: '12px'}}>
                    {record.merchantName}
                  </div>
                </div>
            );
          }
        },
        {
          title: "业务日期",
          dataIndex: "businessDate",
          align: "center",
          width: 80
        },
        {
          title: "订单笔数",
          dataIndex: "orderCount",
          align: "center",
          width: 50,
          customRender: (text) => {
            return <span>{text} 笔</span>
          }
        },
        {
          title: "订单金额",
          dataIndex: "orderAmount",
          align: "center",
          width: 80,
          customRender: (text) => {
            return <Balance amount={text}></Balance>
          }
        },
        {
          title: "分账金额",
          dataIndex: "splitAmountTotal",
          align: "center",
          width: 80,
          customRender: (text) => {
            return <Balance amount={text}></Balance>
          }
        },
        {
          title: "批次状态",
          dataIndex: "batchStatus",
          align: "center",
          width: 80,
          customRender: (text) => {
            return <a-tag color={this.batch_status(text).color}>{this.batch_status(text).label}</a-tag>
          }
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",

          scopedSlots: {customRender: 'action'}
        }
      ],

      // 详情表格列配置
      detailColumns: [
        {
          title: "交易订单号",
          dataIndex: "tradeOrderNo",
          align: "center",
          width: 180,
          ellipsis: true
        },
        {
          title: "分账商户",
          align: "center",
          width: 150,
          customRender: (text, record) => {
            return (
                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '2px', fontSize: '12px'}}>
                    {record.splitMerchantNo}
                  </div>
                  <div style={{color: '#666', fontSize: '11px'}}>
                    {record.splitMerchantName}
                  </div>
                </div>
            );
          }
        },
        {
          title: "收款账户",
          align: "center",
          width: 150,
          dataIndex: "oppAccountNo",
          customRender: (text, row) => {
            if (!text) {
              return <div>-</div>
            }
            return <WalletInfo accountNo={text} accountName={row.oppAccountName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "分账模式",
          dataIndex: "splitMode",
          align: "center",
          width: 100,
          customRender: (text) => {
            return text === '0' ? '指定金额' : '按比例'
          }
        },
        {
          title: "分账金额",
          dataIndex: "splitAmount",
          align: "center",
          width: 120,
          customRender: (text) => {
            return <Balance amount={text}></Balance>
          }
        },
        {
          title: "分账比例",
          dataIndex: "splitRatio",
          align: "center",
          width: 100,
          customRender: (text) => {
            return text ? `${(text * 100).toFixed(2)}%` : '-'
          }
        },

      ],

      // 匹配流水表格列配置
      matchedFlowColumns: [
        {
          title: "流水号",
          dataIndex: "bankSerialNo",
          align: "center",
          width: 180,
          ellipsis: true
        },
        {
          title: "来账金额",
          dataIndex: "tradeAmount",
          align: "center",
          width: 120,
          customRender: (text) => {
            return <Balance amount={text}></Balance>
          }
        },
        {
          title: "已匹配金额",
          dataIndex: "matchAmount",
          align: "center",
          width: 120,
          customRender: (text) => {
            return text ? <Balance amount={text}></Balance> : '-'
          }
        },
        {
          title: "剩余可匹配",
          align: "center",
          width: 120,
          customRender: (text, record) => {
            const netAmount = record.tradeAmount - (record.feeAmount || 0);
            const remainAmount = netAmount - (record.matchAmount || 0);
            const color = remainAmount > 0 ? '#faad14' : '#52c41a';
            return <span style={{color}}>{remainAmount > 0 ? `¥${this.formatAmount(remainAmount)}` : '已满额'}</span>
          }
        },
        {
          title: "来账时间",
          dataIndex: "tradeTime",
          align: "center",
          width: 150,
          customRender: (text) => {
            if (!text) return '-';
            return this.formatDateTime(text);
          }
        },
        {
          title: "付款人",
          align: "center",
          width: 200,
          customRender: (text, record) => {
            return <WalletInfo accountNo={record.oppAccountNo} accountName={record.oppAccountName} showAccountName={true} isWallet={false}></WalletInfo>
          }
        }
      ],
      settleItemsColumns: [
        {
          title: "分账商户",
          align: "center",
          width: 180,
          customRender: (text, record) => {
            return (
                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '2px', fontSize: '12px'}}>
                    {record.splitMerchantNo}
                  </div>
                  <div style={{color: '#666', fontSize: '11px'}}>
                    {record.splitMerchantName}
                  </div>
                </div>
            );
          }
        },
        {
          title: "付款账户",
          align: "center",
          dataIndex: "accountNo",
          width: 180,
          customRender: (text, row) => {
            if (!text) {
              return <div>-</div>
            }
            return <WalletInfo accountNo={text} accountName={row.accountName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "收款账户",
          align: "center",
          dataIndex: "oppAccountNo",
          width: 180,
          customRender: (text, row) => {
            if (!text) {
              return <div>-</div>
            }
            return <WalletInfo accountNo={text} accountName={row.oppAccountName} showAccountName={true}></WalletInfo>
          }
        },
        {
          title: "清算金额",
          dataIndex: "amount",
          align: "center",
          width: 120,
          customRender: (text) => {
            return <Balance amount={text} prefix="￥"></Balance>
          }
        },
        {
          title: "清算状态",
          dataIndex: "settleStatus",
          align: "center",
          width: 100,
          customRender: (text, record) => {
            if (record.settleStatus === '2') {
              return <a-popover placement="top">
                <a-tag color={this.settle_status(text).color}>{this.settle_status(text).label}</a-tag>
                <template slot="content">
                  <p>失败原因：{record.failReason}</p>

                </template>
              </a-popover>
            } else {
              return <a-tag color={this.settle_status(text).color}>{this.settle_status(text).label}</a-tag>
            }
          },
        },
        {
          title: "钱包流水号",
          dataIndex: "walletTradeNo",
          align: "center",
          width: 180,
          ellipsis: true,
          customRender: (text) => {
            return text || '-'
          }
        },
        {
          title: "摘要",
          dataIndex: "remark",
          align: "center",
          width: 150,
          ellipsis: true,
          customRender: (text) => {
            return text || '-'
          }
        },
        {
          title: "清算时间",
          dataIndex: "settleTime",
          align: "center",
          width: 180,
          customRender: (text) => {
            return this.formatDateTime(text)
          }
        }
      ],
    };
  },
  mounted() {
    this.loadMainMerchantList();
  },
  methods: {
    // 获取主商户列表
    async loadMainMerchantList() {
      try {
        const res = await this.api.settleMerchantListApi({
          merchantRelations: '1'
        });
        if (res.code === 200) {
          this.mainMerchantList = res.data || [];
          //初始化筛选参数
          if (this.mainMerchantList.length > 0) {
            this.paramsData.merchantNo = this.mainMerchantList[0]?.merchantNo;
            // 立即查询该商户的数据
            await this.getTableData();
          } else {
            this.$message.warning('暂无商户数据');
          }
        } else {
          this.$message.warning(res.info || '获取商户列表失败');
        }
      } catch (error) {
        console.error('获取商户列表失败:', error);
        this.$message.error('获取商户列表失败');
      }
    },
    // 获取表格数据
    async getTableData() {
      try {
        const res = await this.api.batchPageApi({
          ...this.pagination,
          ...this.paramsData
        });
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      }
    },

    // 查询
    handleQuery() {
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    // 重置
    handleReset() {
      this.paramsData = {
        batchNo: "",
        merchantNo: "",
        merchantName: "",
        batchStatus: "",
        startDate: "",
        endDate: ""
      };
      this.businessDateRange = [];
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    // 日期范围变化
    onDateChange(dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.paramsData.startDate = dateStrings[0];
        this.paramsData.endDate = dateStrings[1];
      } else {
        this.paramsData.startDate = "";
        this.paramsData.endDate = "";
      }
    },

    // 查看详情 - 获取批次详情（含匹配的流水）
    async viewBtn(record) {
      try {
        const res = await this.api.batchDetailWithFlowsApi(record.batchNo);
        if (res.code === 200) {
          this.viewData = res.data;
          this.viewModalVisible = true;
        } else {
          message.warning(res.info || "获取批次详情失败");
        }
      } catch (error) {
        console.error("获取批次详情失败:", error);
      }
    },

    // 自动匹配（当前商户所有待匹配批次和流水）
    async autoMatchBtn() {
      if (!this.paramsData.merchantNo) {
        message.warning("请先选择商户");
        return;
      }
      try {
        const res = await this.api.autoMatchApi(this.paramsData.merchantNo);
        if (res.code === 200) {
          message.success(res.info || "匹配完成");
          this.getTableData();
        } else {
          message.warning(res.info || "匹配失败");
        }
      } catch (error) {
        console.error("匹配失败:", error);
        message.error("匹配失败");
      }
    },

    // 自动匹配（单个批次）
    async autoMatchBatchBtn(record) {
      try {
        const res = await this.api.autoMatchByBatchNoApi(record.batchNo);
        if (res.code === 200) {
          message.success(res.info || "匹配完成");
          this.getTableData();
        } else {
          message.warning(res.info || "匹配失败");
        }
      } catch (error) {
        console.error("匹配失败:", error);
        message.error("匹配失败");
      }
    },

    // 取消批次匹配
    async cancelBatchMatchBtn(record) {
      this.$confirm({
        title: `确认取消批次 ${record.batchNo} 的所有匹配吗？`,
        content: "取消匹配后需要重新进行匹配操作。",
        okText: "确认取消",
        cancelText: "取消",
        okType: "danger",
        onOk: async () => {
          try {
            const res = await this.api.cancelBatchMatchApi(record.batchNo);
            if (res.code === 200) {
              message.success(res.info || "取消匹配成功");
              this.getTableData();
            } else {
              message.warning(res.info || "取消匹配失败");
            }
          } catch (error) {
            console.error("取消匹配失败:", error);
            message.error("取消匹配失败");
          }
        }
      });
    },

    // 按批次生成清分计划试算（预览）
    async genPlanByBatchBtn(record) {
      try {
        this.settleTryonfirmLoading = true;
        const res = await this.api.genPlanTryByBatchApi(record.batchNo);
        if (res.code === 200) {
          this.settleTryData = res.data || {};
          this.settleTryModalVisible = true;
        } else {
          message.warning(res.info || "预览失败");
        }
      } catch (error) {
        console.error("预览失败:", error);
        message.error("预览失败");
      } finally {
        this.settleTryonfirmLoading = false;
      }
    },

    // 关闭清分试算弹窗
    handleSettleTryCel() {
      this.settleTryModalVisible = false;
      this.settleTryData = {};
    },

    // 确认生成清分计划
    async genPlanByBatchConfirmBtn() {
      try {
        this.settleTryonfirmLoading = true;
        const res = await this.api.genPlanByBatchApi(this.settleTryData.batchNo);
        if (res.code === 200) {
          message.success(res.info || "生成清分计划成功");
          this.settleTryModalVisible = false;
          this.settleTryData = {};
          this.getTableData();
        } else {
          message.warning(res.info || "生成清分计划失败");
        }
      } catch (error) {
        console.error("生成清分计划失败:", error);
        message.error("生成清分计划失败");
      } finally {
        this.settleTryonfirmLoading = false;
      }
    },
    // 作废按钮
    invalidBtn(record) {
      this.invalidFormData = {
        batchNo: record.batchNo,
        invalidReason: ""
      };
      this.invalidModalVisible = true;
    },

    // 确认作废
    async handleInvalidConfirm() {
      this.$refs.invalidForm.validate(async (valid) => {
        if (valid) {
          this.invalidConfirmLoading = true;
          try {
            const res = await this.api.batchinvalidApi(this.invalidFormData);
            if (res.code === 200) {
              message.success("作废成功");
              this.invalidModalVisible = false;
              this.getTableData();
            } else {
              message.error(res.info || "作废失败");
            }
          } catch (error) {
            console.error("作废失败:", error);
            message.error("作废失败");
          } finally {
            this.invalidConfirmLoading = false;
          }
        }
      });
    },

    // 取消作废
    handleInvalidCancel() {
      this.invalidModalVisible = false;
      this.$refs.invalidForm.resetFields();
    },

    // 判断是否可以取消匹配
    canCancelMatch(status) {
      // 取消匹配：已匹配、待清算状态可以取消
      return ['1', '2'].includes(status);
    },
    // 状态配置
    settle_status(status) {
      return commonDict.settle_status[status] || commonDict.settle_status.default;
    },
    // 判断是否可以作废
    canInvalid(status) {
      // 作废：待匹配状态可以作废
      return ['0'].includes(status);
    },
// 判断是否可以执行清分
    canSettle(record) {
      // 根据业务逻辑，只有特定状态可以执行清分
      // 这里假设待清算状态可以执行清分
      return record.batchStatus === '2';
    },
    // 执行清分
    async settleBtn(record) {
      try {
        const res = await this.api.executeSettleByBatchApi(record.batchNo);
        if (res.code === 200) {
          message.success("执行清分成功");
          this.viewModalVisible = false;
          this.getTableData();
        } else {
          message.warning(res.info || "执行清分失败");
        }
      } catch (error) {
        console.error("执行清分失败:", error);
        message.error("执行清分失败");
      }
    },

    // 重试清分
    async retrySettleBtn(record) {
      try {
        const res = await this.api.batchSettleRetryApi(record.batchNo);
        if (res.code === 200) {
          message.success(res.info || "重试清分成功");
          this.viewModalVisible = false;
          this.getTableData();
        } else {
          message.warning(res.info || "重试清分失败");
        }
      } catch (error) {
        console.error("重试清分失败:", error);
        message.error("重试清分失败");
      }
    },


    // 状态配置
    batch_status(status) {
      return commonDict.batch_status[status] || commonDict.batch_status.default;
    },


    // 金额格式化
    formatAmount(amount) {
      if (!amount) return '0.00';
      return parseFloat(amount).toFixed(2);
    },

    // 日期时间格式化
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        const date = new Date(dateTime);
        return date.toLocaleString('zh-CN');
      } catch (e) {
        return dateTime;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 20px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select {
      width: 200px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.paginationBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.batch-detail {
  max-height: 70vh;
  overflow-y: auto;
  padding: 4px;

  .detail-section {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    /deep/ .ant-card-head {
      min-height: 40px;
      padding: 0 12px;

      .ant-card-head-title {
        font-size: 14px;
        font-weight: 600;
        padding: 8px 0;
      }
    }

    /deep/ .ant-card-body {
      padding: 12px;
    }
  }

  .detail-value {
    font-weight: 500;
    color: #333;
  }

  .stat-item {
    text-align: center;

    .stat-label {
      font-size: 12px;
      color: #666;
      margin-bottom: 4px;
    }

    .stat-value {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
  }
}

@media (max-width: 768px) {
  .batch-detail {
    .detail-section {
      /deep/ .ant-descriptions-bordered .ant-descriptions-item {
        padding: 8px 12px;
      }
    }
  }
}

/deep/ .ant-descriptions-item-label {
  font-weight: bold;
  background-color: #fafafa;
}

/deep/ .ant-card-head-title {
  .top-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;

    .dianshang {
      margin-left: 50px;
    }
  }
}
</style>
<style scoped>
/* 可选：添加一些辅助样式 */
.detail-value {
  word-break: break-all;
}

.amount-primary {
  color: #1890ff;
  font-weight: bold;
}

.amount-success {
  color: #52c41a;
  font-weight: bold;
}

.amount-warning {
  color: #faad14;
  font-weight: bold;
}

.text-danger {
  color: #ff4d4f;
}

.stats-container {
  margin-bottom: 16px;
  background-color: #fafafa;
  padding: 12px;
  border-radius: 4px;
}

.stat-item {
  text-align: center;
}

.stat-label {
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 16px;
  font-weight: 500;
}

.status-action-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.copyable:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 2px;
  padding: 2px;
}
</style>